/**
 * @description 字典
 */
import request from "@/utils/request";
// 获取字典数据
export function queryDictList(type) {
  return request({
    url: `/dict/type?type=${type}`,
    method: "get",
  });
}
